<template>
  <div>
    <v-data-table 
      :headers="headers" 
      :items="rows" 
      class="elevation-1 ma-0 tableCust"
      :footer-props="{
        'items-per-page-text': $t('dataTable.rowsPerPageText'),
        'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
      }"
      :no-data-text="$t('dataTable.noDataText')"
      :headerProps="{
        'sort-by-text': $t('dataTable.sortByText')
      }"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">

          <v-dialog v-model="createRaceDialog" max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2 primary" v-on="on" @click="loadSelectInputRaces()">
                <v-icon left dark>fa-plus</v-icon>
                {{ $t('page.series.create-race') }}
              </v-btn>
            </template>
            <v-card class="borderDialog">
              <v-card-title>
                <span class="headline">{{ $t('page.series.create-race') }}</span>
              </v-card-title>
              <v-card-text>
                <v-form ref="formSS" class="pt-4 inputSeries">
                  <v-row>
                    <v-col cols="12" class="text-left">
                      {{ $t('page.series.add-series-text1') }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-autocomplete 
                        v-model="selectEvent"
                        :items="eventsItems"
                        :label="$t('page.series.event')"
                        :rules="[ v => !!v || $t('page.series.event-required') ]"
                        outlined dense 
                        :no-data-text="$t('common.no_data')"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field 
                        outlined dense 
                        :label="$tc('page.series.race-name')" 
                        v-model="raceName" 
                        :rules="[
                          (v) => $inputRules({ value: v }, 'filled') || $t('page.series.error-raceName-required'),
                          (v) => {
                            const result = $inputRules({value: v, minSize: 3, maxSize: 255, trim: true}, 'fieldLength');
                            if(!result) {
                              if((v || '').length < 3) return $t('page.series.error-raceName-min');
                              if((v || '').length > 255) return $t('page.series.error-raceName-max');
                            }
                            return true;
                          }
                        ]"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field type="number" outlined dense :label="$t('common.table.race-order')"
                        v-model="raceOrderD" :rules="[
                          (v) => $inputRules({value: v}, 'integer') || $t('page.series.rule-raceOrder')
                        ]"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                      <v-col cols="12">
                          <v-text-field type="number" outlined dense min="1" :label="$tc('common.table.point-multiplier')"
                              v-model="pointsMultiplier" :rules="[
                              (v) => $inputRules({value: v}, 'integer') || $t('page.series.error-point-multiplier-invalid'),
                              (v) => v > 0 || $t('page.series.rule-point-multiplier-greater-than-zero')
                              ]" :hint="$tc('page.series.point-multiplier-hint')" persistent-hint></v-text-field>
                      </v-col>
                  </v-row>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" small text @click="closeCreateRaceDialog">{{ $t('common.form.cancel')
                  }}</v-btn>
                <v-btn color="blue darken-1" small text @click="addRace">{{ !bandEdit ? $t('common.form.create') :
                  $t('common.form.save') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          
          <DialogAddRace 
            ref="dialogAddRace" 
            :dialog="dialog"
            :bandEdit="bandEdit"
            :reopenEdition="reopenEdition" 
            @change="changeField" 
            @loadRaces="loadRaces" 
          />

          <v-dialog v-model="addExistingRaceDialog" max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2 ml-2 primary" v-on="on" @click="loadSelectInputRaces()"
                :disabled="seriesSelected ? false : true">
                <v-icon left dark>fa-plus</v-icon>
                {{ $t('page.series.add-to-existing-race') }}
              </v-btn>
            </template>
            <v-card class="borderDialog">
              <v-card-title>
                <span class="headline">{{ $t('page.series.add-to-existing-race') }}</span>
              </v-card-title>
              <v-card-text>
                <v-form ref="formAddToExistingRace" class="pt-4 inputSeries">
                  <v-row>
                    <v-col cols="12">
                      <v-autocomplete 
                        v-model="addToExistingImportFromRaceId"
                        :items="selectRaceItems"
                        :label="$t('page.series.label-select-import-race-scores-from')"
                        :rules="[ v => !!v || $t('page.series.race-required') ]"
                        outlined dense
                        :no-data-text="$t('common.no_data')"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-autocomplete 
                        v-model="addToExistingRaceDestinationId"
                        :items="selectCurrentSeriesRaceItems"
                        :label="$t('page.series.label-select-destination-race')"
                        :rules="[ v => !!v || $t('page.series.race-required') ]"
                        outlined dense
                        :no-data-text="$t('common.no_data')"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" small text @click="addExistingRaceDialog = false">{{
                  $t('common.form.cancel') }}</v-btn>
                <v-btn color="blue darken-1" small text @click="addToExistingRace">{{ $t('common.form.add') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogSerie" max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2 primary ml-2" v-on="on" @click="loadSelectInputRaces()">
                <v-icon left dark>fa-plus</v-icon>
                {{ $t('common.form.add-series') }}
              </v-btn>
            </template>
            <v-card class="borderDialog">
              <v-card-title>
                <span class="headline">{{ $t('common.form.add-series') }}</span>
              </v-card-title>
              <v-card-text>
                <v-form ref="formSS" class="pt-4 inputSeries">
                  <v-row>
                    <v-col cols="12" class="text-left">
                      {{ $t('page.series.add-series-text1') }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-autocomplete 
                        v-model="selectSerie"
                        :items="seriesItems"
                        :label="$t('page.series.serie')"
                        :rules="[ v => !!v || $t('page.series.serie-required') ]"
                        outlined dense
                        :no-data-text="$t('common.no_data')"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-autocomplete 
                        v-model="selectEvent"
                        :items="eventsItems"
                        :label="$t('page.series.event')"
                        :rules="[ v => !!v || $t('page.series.event-required') ]"
                        outlined dense
                        :no-data-text="$t('common.no_data')"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field 
                        outlined dense 
                        :label="$tc('page.series.race-name')" 
                        v-model="raceName" :rules="[
                          (v) => $inputRules({ value: v }, 'filled') || $t('page.series.error-raceName-required'),
                          (v) => {
                            const result = $inputRules({value: v, minSize: 3, maxSize: 255, trim: true}, 'fieldLength');
                            if(!result) {
                              if((v || '').length < 3) return $t('page.series.error-raceName-min');
                              if((v || '').length > 255) return $t('page.series.error-raceName-max');
                            }
                            return true;
                          }
                        ]"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field type="number" outlined dense :label="$t('common.table.race-order')"
                        v-model="raceOrderD" :rules="[
                          (v) => $inputRules({value: v}, 'integer') || $t('page.series.rule-raceOrder')
                        ]"></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" small text @click="closeSerie">{{ $t('common.form.cancel') }}</v-btn>
                <v-btn color="blue darken-1" small text @click="saveSerie">{{ $t('common.form.create') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon v-if="(item.sourceIds || '').length > 0" small class="mr-2" @click="editSourceRaceItem(item)">fas fa-unlink</v-icon>
        <v-icon small @click="confirmDelete(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
    <DialogSourceRace
      ref="resetDialogDelete"
      :dialog="dialogSourceRace"
      @updateDialog="(value) => dialogSourceRace = value"
      :raceItem="raceItemSelected"
      @showError="showError"
      :isShowError="dialogAlert"
      @refreshRaces="loadRaces"
    ></DialogSourceRace>
    <SGSNotificationConfirm 
      v-if="dialogNotification" 
      :notificationMessage="confirmDeleteRaceMessage"
      @cancel="dialogNotification=false;" 
      @agree="deleteItem" 
      type='warning' 
      :acept="$t('common.form.delete')"
      :reject="$t('common.form.cancel')" 
    />
    <SGSNotificationAlert 
      v-if="dialogAlert" 
      :notificationMessage="alertMessage" 
      @cancel="closeAlert" 
      type='error' 
    />
    <v-snackbar v-model="snackbar" timeout="3000" :color="color_snackbar">
      {{ msg_snackbar }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          <v-icon>fas fa-times-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import { mapGetters, mapState } from "vuex";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
import SGSNotificationAlert from "@/components/custom/notification/NotificationAlert.vue";
import DialogSourceRace from "@/components/series/components/DialogSourceRace.vue";
import DialogAddRace from "@/components/series/components/DialogAddRace.vue";

export default {
  mixins: [apiCalls],
  components: { SGSNotificationConfirm, SGSNotificationAlert, DialogSourceRace, DialogAddRace },
  data() {
    return {
      selectedRace: null,
      selectRaceItems: [],
      raceOrder: 1,
      dialogNotification:false,
      createRaceDialog: false,
      dialog: false,
      addExistingRaceDialog: false,
      dialogSerie: false,
      item: {},
      editedIndex: -1,
      editedItem: {
        raceId: "",
        raceName: 0
      },
      defaultItem: {
        raceId: "",
        raceName: 0
      },
      editorType: "new",
      snackbar: false,
      color_snackbar: '',
      msg_snackbar: '',
      seriesItems: [],
      eventsItems: [],
      selectSerie: null,
      selectEvent: null,
      raceName: null,
      raceOrderD: 1,
      series: [],
      bandEdit: false,
      bonusPoints: 0,
      selectedItem: null,
      dialogAlert: false,
      alertMessage: '',
      reopenEdition: false,
      indexDialog: 'dialog',
      addToExistingImportFromRaceId: null,
      addToExistingRaceDestinationId: null,
      selectCurrentSeriesRaceItems: [],
      dialogSourceRace: false,
      raceItemSelected: null,
      dialogDeleteSourceRace: false,
      pointsMultiplier: 1
    };
  },
  computed: {
    ...mapState({
      seriesSelected: state => state.series.seriesSelected,
    }),
    ...mapGetters({
      races: 'getRacesList',
      bSeriesResults: 'getBSeriesResults',
      raceSelected: 'getRaceSelected'
    }),
    formTitle() {
      return this.editedIndex === -1 ? this.$t('page.series.add-race') : this.$t('page.series.edit-race');
    },
    confirmDeleteRaceMessage() {
      if (this.item && this.item.eventName != null && this.item.raceName != null) {
        return this.$t('page.series.confirm-delete-race', {
          eventName: this.item.eventName,
          raceName: this.item.raceName
        });
      }
      return this.$t('common.confirm-delete');
    },
    rows() {
      return this.races.map((element) => {
        return {
          ...element, 
          raceEventName: `${this.$escapeHtml.decode(element.eventName)} :: ${this.$escapeHtml.decode(element.raceName)}`, 
          raceName: this.$escapeHtml.decode(element.raceName),
          eventName: this.$escapeHtml.decode(element.eventName),
          actions: "actions"
        };
      })
    },
    headers() {
      return [
        {
          text: this.$t("common.table.id"),
          align: "start",
          value: "raceId"
        },
        {
          text: this.$t("common.table.event"),
          value: "eventName"
        },
        {
          text: this.$t("common.table.race"),
          value: "raceName"
        },
        {
          text: this.$t("common.table.source_races"),
          value: "sourceIds"
        },
        {
          text: this.$t("common.table.event-date"),
          value: "eventDate",
          width: '130px'
        },
        {
          text: this.$t("common.table.race-order"),
          value: "raceOrder"
        },
        {
          text: this.$t("common.table.bonus-points"),
          value: "bonusPoints"
        },
        {
          text: this.$t("common.table.actions"),
          value: "actions",
          sortable: false,
          width: '130px'
    }
      ];
    }
  },
  watch: {
    dialogSerie(val) {
      if(val) {
        if(this.$refs.formSS) this.$refs.formSS.resetValidation();
        if(!this.reopenEdition) this.selectSerie = this.selectEvent = this.raceName = null;
        let nums = this.rows.map((el) => {
          return parseInt(el.raceOrder);
        }).filter((el) => !!el);
        this.raceOrderD = nums.length > 0 ? (Math.max(...nums) + 1) : 1;
      }
      val || this.closeSerie();
    },
    seriesSelected() {
      this.loadRaces();
      this.seriesItems = this.series.map((el) => {
        return {
          value: el.id,
          text: `${el.id} - ${this.$escapeHtml.decode(el.seriesName)}`
        }
      }).filter((el) => {
        return el.value != this.seriesSelected.id;
      });
    },
    createRaceDialog(val) {
      if(val) {
        this.pointsMultiplier = 1;
        if(!this.reopenEdition) {
          let nums = this.rows.map((el) => {
            return parseInt(el.raceOrder);
          }).filter((el) => !!el);
          this.raceOrderD = nums.length > 0 ? (Math.max(...nums) + 1) : 1;
        }
      }
    }
  },
  methods: {
    init()
    {
      this.loadRaces();
      this.loadSeries();
      this.loadEvents();
    },
    async loadSelectInputRaces(changeValue = false) {
      const races = await this.getApi('/api/v1/promoter/series/races-select');

      this.selectRaceItems = [];
      this.selectCurrentSeriesRaceItems = [];
      const seriesRaces = this.rows.map(obj => obj.raceId);
      races.forEach(element => {
        const row = { value: element.raceId, text: `${element.raceId} - ${this.$escapeHtml.decode(element.raceName)} :: ${element.eventId} - ${this.$escapeHtml.decode(element.eventName)}`  };
        this.selectRaceItems.push(row);
        if(seriesRaces && seriesRaces.includes(element.raceId))
        {
          this.selectCurrentSeriesRaceItems.push(row);
        }
      });
      if(changeValue) {
        this.selectedRace = changeValue;
      }
      if(this.$refs.formAddToExistingRace) {
        this.$refs.formAddToExistingRace.reset();
      }
    },
    async loadRaces() {
      if(this.seriesSelected) {
        this.$store.dispatch('getRacesListAction',this.seriesSelected.id);
      }
    },
    async loadSeries() {
      const response = await this.getApi(
        "/api/v1/promoter/series"
      );
      this.series = response;
      this.seriesItems = response.map((el) => {
        return {
          value: el.id,
          text: `${el.id} - ${this.$escapeHtml.decode(el.seriesName)}`
        }
      }).filter((el) => {
        return el.value != this.seriesSelected.id;
      });
    },
    async loadEvents() {
      const response = await this.getApi(
        "/api/v1/promoter/event"
      );
      this.eventsItems = response.map((el) => {
        return {
          value: el.id,
          text: `${el.id} - ${this.$escapeHtml.decode(el.eventName)}`
        }
      });
    },
    newItem() {
      this.editorType = "new";
    },
    confirmDelete(item){
      this.dialogNotification = true;
      this.item = item;
    },
    async deleteItem() {
      const { id, raceId } = this.item;
      const response = await this.api('DELETE', `/api/v1/promoter/series/race/${id}`); 
      if(response && !response.error){
        if(this.bSeriesResults && (this.raceSelected == -1 || this.raceSelected == raceId)) {
            if(this.raceSelected == raceId) {
              this.$store.commit('setRaceSelected', -1);
            }
            this.$store.dispatch('getResultsAction', { seriesId: this.seriesSelected.id });
        }
        this.loadRaces();
        this.loadSeries();
        this.loadEvents();
        //This is responsible for closing the deletion dialog
        this.dialogNotification = false
      } else if(response.error) {
          if(response && response.error && Array.isArray(response.error) && response.error.length > 0) {
            this.dialog = false;
            this.dialogAlert =  true;
            this.alertMessage = this.$t('page.series.'+response.error[0]);
          } else if(response.error && typeof response.error == 'string') {
            this.dialog = false;
            this.dialogAlert =  true;
            this.alertMessage = this.$t('page.series.'+response.error);
          } else {
            this.dialog = false;
            this.dialogAlert =  true;
            this.alertMessage = this.$t('common.failed-save');
          }
      } else {
        this.dialog = false;
        this.dialogAlert =  true;
        this.alertMessage = this.$t('common.failed-save');
      }
    },
    close() {
      this.dialog = false;
      const parent = this;
      setTimeout(function() {
        if(parent.bandEdit) parent.bandEdit = false;
      }, 1000);
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeCreateRaceDialog()
    {
      this.createRaceDialog = false;
      this.$refs.formSS.reset();
    },
    closeSerie() {
      this.dialogSerie = false;
    },
    closeAlert() {
      this.dialogAlert = false;
      if(this.reopenEdition){
        this[this.indexDialog] = true;
      }
    },
    handleError(response, fallbackKey, dialogName) {
      this[dialogName] = false;
      this.indexDialog = dialogName;
      this.dialogAlert = true;
      this.alertMessage = response && response.error 
          ? this.$t('page.series.' + (Array.isArray(response.error) ? response.error[0] : response.error)) 
          : this.$t(fallbackKey);
      this.reopenEdition = true;
    },
    async addToExistingRace()
    {
      if(!this.$refs.formAddToExistingRace.validate())
      {
        return;
      }

      const races = await this.api('post', '/api/v1/promoter/series/table/race/addToExistingRace', {
        importFromRaceId: this.addToExistingImportFromRaceId,
        destinationRaceId: this.addToExistingRaceDestinationId
      });
      
      if (races && races.success && !races.error)
      {
        this.loadRaces();
        this.$store.dispatch("importScoresAction", { raceId: this.addToExistingImportFromRaceId });
        if(this.bSeriesResults && (this.raceSelected == -1 || this.raceSelected == this.addToExistingRaceDestinationId)) {
            this.$store.dispatch('getResultsAction', { seriesId: this.seriesSelected.id, raceId: this.raceSelected });
        }
        this.addExistingRaceDialog = false;
        return;
      } else {
        this.handleError(races,'common.failed-save', 'addExistingRaceDialog');
      }
    },
    async save() {
      if(this.$refs.formSR.validate()) {
        let data = {
          seriesId: this.seriesSelected.id,
          raceId: this.selectedRace,
          raceOrder: this.raceOrder,
          bonusPoints: this.bonusPoints,
          pointMultiplier: this.pointsMultiplier
        }

        if(this.bandEdit) {
          data.id = this.selectedItem ? this.selectedItem.id : null;
        }

        const races = await this.api("post", "/api/v1/promoter/series/table/race",data);
        
        if(races && races.success && !races.error){
          this.$store.dispatch("importScoresAction",{ raceId: this.selectedRace });
          if(!this.bandEdit) {
            if(this.bSeriesResults && this.raceSelected == -1) {
              this.$store.dispatch('getResultsAction', { seriesId: this.seriesSelected.id });
            }
          }
          this.loadRaces();
          this.close();
          this.reopenEdition = false;
        } else {
          this.handleError(races,'common.failed-save', 'dialog');
        }
      }
    },
    async saveSerie() {
      if(this.$refs.formSS.validate()) {
        this.closeSerie();
        let data = {
          currentSeriesId: this.seriesSelected.id,
          raceName: this.raceName,
          raceOrder: this.raceOrderD
        };

        const response = await this.api("post", "/api/v1/promoter/series/export/"+this.selectSerie+"/"+this.selectEvent,data);
        
        if(response && response.success && !response.error) {
          if(this.bSeriesResults && this.raceSelected == -1) {
              this.$store.dispatch('getResultsAction', { seriesId: this.seriesSelected.id });
          }
          this.loadRaces();
          this.closeSerie();
          this.reopenEdition = false;
        } else {
          this.handleError(response,'common.failed-save', 'dialogSerie');
        }
      }
    },
    async addRace()
    {
      if(this.$refs.formSS.validate()) {
        let data = {
          currentSeriesId: this.seriesSelected.id,
          raceName: this.raceName,
          raceOrder: this.raceOrderD,
          pointMultiplier: this.pointsMultiplier
        };

        const response = await this.api("post", `/api/v1/promoter/series/table/race/event/${this.selectEvent}`, data);
        
        if(response && response.success && !response.error) {
          this.loadRaces();
          this.closeCreateRaceDialog();
          this.reopenEdition = false;
        } else {
          this.handleError(response,'common.failed-save', 'createRaceDialog');
        }
      }
    },
    async editItem(item) {
      this.bandEdit = true;
      const refDialogAddRace = this.$refs.dialogAddRace;
      if(refDialogAddRace) {
        refDialogAddRace.editItem(item);
      }
    },
    editSourceRaceItem(item) {
      this.dialogSourceRace = true;
      this.raceItemSelected = item;
      if(this.$refs.resetDialogDelete) {
        this.$refs.resetDialogDelete.reset();
      }
    },
    showError({ display, msg }) {
        this.dialogAlert = display;
        this.alertMessage = msg;
    },
    changeField({ index, value }) {
      this[index] = value;
    }
  }
};
</script>

<style scoped>
.theme--dark.v-btn.v-btn--disabled {
    opacity: 0.9;
}
.v-application .headline {
  font-size: 24px !important;
}
.v-dialog > .v-card > .v-card__text {
    padding: 0 40px 20px;
}
.v-card__actions .v-btn {
    background-color: var(--v-primary-darken2) !important;
    color: white !important;
}
</style>
<style scss>
.tableCust .v-data-table-header-mobile__wrapper, 
.tableCust1 .v-data-table-header-mobile__wrapper, 
.tableCust2 .v-data-table-header-mobile__wrapper {
  margin-top: .7rem;
}
.tableCust header, .tableCust1 header, .tableCust2 header {
  padding-left: 12px;
}
@media (max-width: 1140px) {
  .tableCust2 header, .tableCust2 header .v-toolbar__content {
    height: auto !important;
  }
  .tableCust2 header .v-toolbar__content .v-item-group {
    display: block;
  }
  .tableCust2 header .v-toolbar__content .v-btn {
    float: left;
    margin-left: 0 !important;
    margin-right: .5rem !important;
  }
  .tableCust2 header .v-toolbar__content .v-btn {
    border-radius: inherit;
    white-space: normal;
    display: block;
  }
}
@media (max-width: 700px) {
  .tableCust header, .tableCust header .v-toolbar__content {
    height: auto !important;
  }
  .tableCust header .v-toolbar__content {
    display: block;
  }
  .tableCust header .v-toolbar__content .v-btn {
    float: left;
    margin-left: 0 !important;
    margin-right: .5rem !important;
  }
}
</style>